import { defineMessages } from '@cookbook/solid-intl'

// Split out of `all-featured-destination-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Browse vacation rentals across every Lodgr destination. Book stays directly with hosts — no added guest fees.',
        id: 'AllFeaturedDestinationPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'All Vacation Rentals | Lodgr',
        id: 'AllFeaturedDestinationPage.titleMessage',
    }),
}
